var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.426 15v-1.982l4.54-4.483c1.983-1.924 2.52-2.637 2.52-3.623v-.03c0-1.2-.82-2.04-2.168-2.04-1.377 0-2.324.918-2.324 2.256v.048H.27l-.01-.039c0-2.705 2.11-4.56 5.195-4.56 2.9 0 4.932 1.66 4.932 4.092v.029c0 1.602-.83 2.93-3.399 5.303l-2.607 2.431v.225h6.21V15H.427z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/number-2.70b65937a6d9d1fea808084d12e279fb.svg";
export { ForwardRef as ReactComponent };